module.exports = __webpack_public_path__ + "files/d83bc8ad2879b8cac03a06dc33b3ab02.png";